/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import CommunityChallengeActiveItem from '@/mixins/CommunityChallengeActiveItem';

/**
 * Challenge Progress component.
 * @author Mark Thompson <mthompson@frontier.co.uk>
 */
@Component({
    name: 'c-community-challenge-progress',
})
export default class CommunityChallengeProgress extends mixins(CommunityChallengeActiveItem) {

}
